import { rootReducer } from "./reducer";
import { createStore } from "redux";

export const appStore = createStore(rootReducer);